module.exports = __webpack_public_path__ + "img/bg-carbon-5.f44c3de1.png";